<script setup lang="ts">

</script>

<template>
<h1>This is your dashboard. You should be authenticated.</h1>
</template>

<style scoped lang="scss">

</style>